<!--工单类型管理界面-->
<template>
	<div class="orderTypeContainer">
		<div class="searchContainer">
			<el-form ref="form" :model="form" label-width="80px" size="medium" style="display: flex;width: auto;">
				<el-form-item label="紧急程度">
					<el-select v-model="form.priority" clearable placeholder="请选择">
					    <el-option
					      v-for="item in priorityList"
					      :key="item.value"
					      :label="item.name"
					      :value="item.value">
					    </el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-row>
				<el-button type="primary" size="mini" @click="search">查 询</el-button>
			</el-row>
		</div>
		<div class="orderTypeList custom-scrollbar">
			<div class="orderTypeListContainer">
				<div class="orderTypeItem" v-for="item in filterDataList">
					<p class="orderTypeTitle">{{ item.name }}</p>
					<div class="orderTypeContent">
						<p><span class="typeLabel">创建时间：</span>{{ new Date(item.createTime).formatByDate() }}</p>
						<p><span class="typeLabel">创建人：</span>{{ item.creatorName }}</p>
						<p><span class="typeLabel">紧急程度：</span>{{ priorityMatch[item.priority] }}</p>
					</div>
					<div class="orderTypeFooter">
						<button @click="deleteOrderType(item)">删 除</button><button @click="editOrderType(item)">编 辑</button>
					</div>
				</div>
				<div class="addOrderTypeBtn">
					<img @click="addOrderType" :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" />
				</div>
			</div>
		</div>
		<UpdateOrderTypeDialog ref='updateOrderType'></UpdateOrderTypeDialog>
	</div>
</template>

<script>
	import UpdateOrderTypeDialog from './UpdateOrderTypeDialog.vue'
	export default {
		components: {
			UpdateOrderTypeDialog
		},
		props: {},
		data() {
			return {
				form: {
					priority: ''
				},
			}
		},
		created() {},
		mounted() {
		},
		destroyed() {},
		computed: {
			priorityList() {
				return this.$store.orderGroupStore.state.priorityList
			},
			dataList() {
				return this.$store.orderGroupStore.getters.getOrderGroupTree
			},
			priorityMatch() {
				return this.$store.orderGroupStore.state.priorityMatch
			},
			filterDataList() {
				return isempty(this.dataList) ? [] : this.dataList.filter(item => {
					return this.form.priority == '' || this.form.priority == item.priority
				})
			},
		},
		watch: {},
		methods: {
			search() {
				this.$store.orderGroupStore.commit('getOrderGroupTree')
			},
			addOrderType() {
				this.$refs.updateOrderType.open('新建工单类型', {}, result => {
					var sort = 0
					this.dataList.forEach(item => {
						sort = sort < item.sort ? item.sort : sort
					})
					sort += 1
					this.save(result.name, result.priority, undefined, sort)
				})
			},
			save(name, priority, parentId, sort) {
				this.$api.orderGroupApi.addOrderGroup(name, priority, parentId, sort, res => {
					this.$message({
						message: '保存成功!',
						type: 'success'
					})
					this.search()
				}, err => {
					this.$message({
						message: err,
						type: 'error'
					})
				})
			},
			deleteOrderType(item) {
				if ([1, 2, 3].includes(item.groupId)) {
					this.$message({
						message: '默认分组不允许删除!',
						type: 'warning'
					})
					return
				}
				this.$dialogMethod.openAgreeDialog('删除工单组', '删除后所有此分组下工单将归入未分组工单，是否继续?', respon => {
					this.$api.orderGroupApi.deleteOrderGroup(item.groupId, respon => {
						this.search()
					})
				})
			},
			editOrderType(item) {
				if ([1, 2, 3].includes(item.groupId)) {
					this.$message({
						message: '默认分组不允许编辑!',
						type: 'warning'
					})
					return
				}
				this.$refs.updateOrderType.open('编辑工单类型', {name: item.name, priority: item.priority}, result => {
					this.$api.orderGroupApi.updateOrderGroup(item.groupId, result.name, result.priority, respon => {
						this.$message({
							message: '编辑工单类型成功!',
							type: 'success'
						})
						this.search()
					}, err => {
						this.$message({
							message: err,
							type: 'error'
						})
					})
				})
			},
		}
	}
</script>

<style scoped>
	.orderTypeContainer {
		background-color: #FFFFFF;
	}
	
	.searchContainer {
		display: flex;
		justify-content: space-between;
		padding: 12px 20px;
		border-bottom: solid 1px #E4E4E4;
	}
	
	.searchContainer>>>.el-form-item {
		margin-bottom: 0;
	}
	
	.orderTypeList {
		height: calc(100% - 65px);
		box-sizing: border-box;
		padding: 10px 20px;
	}
	
	.orderTypeListContainer {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: flex-start;
	}
	
	.orderTypeItem {
		border: solid 1px #E4E4E4;
		border-radius: 5px;
		width: calc((100% - 132px) / 6);
		margin: 0 24px 12px 0;
		overflow: hidden;
		height: 182px;
	}
	
	.orderTypeItem:nth-child(6n) {
		margin-right: 0;
	}
	
	.orderTypeTitle {
		background-color: #0099FF;
		color: #FFFFFF;
		line-height: 34px;
		text-align: center;
	}
	
	.orderTypeContent {
		padding: 10px;
	}
	
	.orderTypeContent>p {
		line-height: 32px;
		height: 32px;
	}
	
	.typeLabel {
		color: #CCCCCC;
	}
	
	.orderTypeFooter {
		display: flex;
	}
	
	.orderTypeFooter>button {
		width: 50%;
		height: 32px;
		cursor: pointer;
	}
	
	.orderTypeFooter>button:first-child {
		border-right: solid 1px #E4E4E4;
		color: #999999;
	}
	
	.orderTypeFooter>button:last-child {
		color: #0099FF;
	}
	
	.addOrderTypeBtn {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 184px;
		width: calc((100% - 120px) / 6);
		cursor: pointer;
	}
</style>